import { render, staticRenderFns } from "./Critical.vue?vue&type=template&id=92685230"
import script from "./Critical.vue?vue&type=script&lang=js"
export * from "./Critical.vue?vue&type=script&lang=js"
import style0 from "./Critical.vue?vue&type=style&index=0&id=92685230&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports